import { inject, injectable } from 'inversify';
import {
  OrdersRepositoryInterface,
  GetOrderByIdParams,
  GetAllOrdersParams,
  MarkOrderAsDeliveredRequestPayload,
  GetOrderByFiltersParams,
} from '../domain/OrdersRepositoryInterface';
import OrdersService from 'src/features/orders/data/service/OrdersService';
import {
  CreateOrderParams,
  UploadPaymentReceiptParams,
} from 'features/orders/data/service/OrdersService.types.ts';

@injectable()
class OrdersRepository implements OrdersRepositoryInterface {
  @inject(OrdersService) private ordersService!: OrdersService;

  async getOrderById(params: GetOrderByIdParams) {
    const response = await this.ordersService.getOrderById(params);

    return response.data;
  }

  async getOrderByFilters(params: GetOrderByFiltersParams) {
    const response = await this.ordersService.getOrderByFilters(params);

    return response.data;
  }

  async getOrders(params: GetAllOrdersParams) {
    const response = await this.ordersService.getOrders(params);

    return response.data;
  }

  async createOrder(params: CreateOrderParams) {
    const response = await this.ordersService.createOrder(params);

    return response.data;
  }

  async markOrderAsDelivered(params: MarkOrderAsDeliveredRequestPayload) {
    const response = await this.ordersService.markAsDelivered(params);

    return response.data;
  }

  async uploadPaymentReceipt(params: UploadPaymentReceiptParams) {
    const response = await this.ordersService.uploadPaymentReceipt(params);

    return response.data;
  }
}

export default OrdersRepository;
